import { render, staticRenderFns } from "./charts-nav.vue?vue&type=template&id=2c5d7678&"
import script from "./charts-nav.vue?vue&type=script&lang=js&"
export * from "./charts-nav.vue?vue&type=script&lang=js&"
import style0 from "./charts-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./charts-nav.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports